<span class="title">
  {{ title }}
</span>

<div class="message">
  @if (!job.done && !job.skipProgressBar && job.total > 1) {
    <span> {{ job.count }}/{{ job.total }} ({{ job.pctProgress }}%) </span>
  }
  @if (message) {
    <span [innerHTML]="message"></span>
  }
</div>
